export default __webpack_public_path__ + "static/057-b14a76741606169fb18e56ed092db493.jpg";